// extracted by mini-css-extract-plugin
export default {"editHeadingDiv":"EditListingHealthPanel_editHeadingDiv__UUOgZ","form":"EditListingHealthPanel_form__xDV+r"};